import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';

const canShowCompanyHeadquarterField = (userHeadquarterList, fields) => {
  if (!fields || !fields.companyHeadquarterListId) {
    return true;
  }

  return fields.companyHeadquarterListId.every((companyHeadquarterId) => {
    return userHeadquarterList
      .map((x) => x.CompanyHeadquarter.id)
      .includes(companyHeadquarterId);
  });
};

const Stamp = ({ fields, userHeadquarterList, selectedUserHeadquarter }) => [
  {
    name: 'companyHeadquarterListId',
    validation: yup
      .array()
      .of(yup.string())
      .nullable(false),
    type: FormFieldType.SELECT_CHIP,
    value:
      fields && fields.companyHeadquarterListId
        ? fields.companyHeadquarterListId
        : [selectedUserHeadquarter],
    options: userHeadquarterList.map((x) => {
      return { id: x.CompanyHeadquarter.id, name: x.CompanyHeadquarter.name };
    }),
    fullWidth: true,
    enabled: canShowCompanyHeadquarterField(userHeadquarterList, fields)
  },
  {
    name: 'type',
    validation: yup.string().nullable(true),
    type: FormFieldType.SELECT,
    value: fields && fields.type ? fields.type : '',
    options: ['INVOICE', 'CREDIT_NOTE']
      .map((x) => {
        return { id: x, name: x };
      })
      .concat({ id: '', name: '-' }),
    readonly: fields && fields.id,
    fullWidth: true
  },
  {
    name: 'documentStamp',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.documentStamp ? fields.documentStamp : '',
    readonly: fields && fields.id,
    fullWidth: true
  },
  {
    name: 'printStamp',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.printStamp ? fields.printStamp : '',
    readonly: fields && fields.id,
    fullWidth: true
  },
  {
    name: 'numberingFrom',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.numberingFrom ? fields.numberingFrom : '0',
    readonly: fields && fields.id,
    fullWidth: true
  },
  {
    name: 'numberingTo',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.numberingTo ? fields.numberingTo : '0',
    readonly: fields && fields.id,
    fullWidth: true
  },
  {
    name: 'validityFrom',
    validation: yup.date().required('fieldRequired'),
    type: FormFieldType.DATE,
    value: fields && fields.validityFrom ? fields.validityFrom : new Date(),
    readonly: fields && fields.id,
    fullWidth: true
  },
  {
    name: 'validityTo',
    validation: yup.date().required('fieldRequired'),
    type: FormFieldType.DATE,
    value: fields && fields.validityTo ? fields.validityTo : new Date(),
    readonly: fields && fields.id,
    fullWidth: true
  }
];

export default Stamp;
